import React from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import './index.scss';

export default class NativeSelect extends React.Component {
  static displayName = 'NativeSelect';
  static propTypes = {
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
    disabled: PropTypes.bool,
  };
  static defaultProps = {
    value: null,
    disabled: false,
  };

  _changed(e) {
    e.preventDefault();
    this.props.onChange(e.currentTarget.value);
  }

  _iconClicked(e) {
    try {
      let event = document.createEvent('MouseEvents');
      event.initMouseEvent('mousedown', true, true, window);
      findDOMNode(this.refs.select).dispatchEvent(event);
    } catch (e) {
      // Most browsers do not support initMouseEvent,
      // so we want this to fail silently.
    }
  }

  _renderOptions() {
    return this.props.options.map(this._renderOption);
  }

  _renderOption(option, index) {
    return (
      <option key={index} value={option.value}>
        {option.text}
      </option>
    );
  }

  _renderPlaceholder() {
    let option = {
      value: '',
      text: this.props.placeholder,
    };
    return this._renderOption(option, 0);
  }

  render() {
    return (
      <div className="NativeSelect-Wrapper uikit">
        <select
          ref="select"
          className="NativeSelect"
          value={this.props.value}
          onChange={this._changed.bind(this)}
          disabled={this.props.disabled}
          data-testid={this.props.dataTestId}
        >
          {!!this.props.placeholder ? this._renderPlaceholder() : null}
          {this._renderOptions()}
        </select>
        <span
          className="NativeSelect-icon af-icon af-angle-down"
          onClick={this._iconClicked.bind(this)}
        ></span>
      </div>
    );
  }
}
